import { useCallback } from "react";
import { useMutation, useQuery } from "react-query";

import { MUTATION_KEYS, QUERY_KEYS } from "../../../constants/queryKeys";
import { CouponsApi } from "../../../services";

export const useProviderCodes = (countryCode: string) => {
  const fetchProviderCodes = async (): Promise<string[]> => {
    const response = await CouponsApi.init().getProviders(countryCode);
    return response.data.map((provider) => provider.code);
  };

  const queryResult = useQuery<string[], Error & { error_code: string }>(
    [QUERY_KEYS.providerCodes, countryCode],
    fetchProviderCodes,
    {
      retry: false,
      refetchOnWindowFocus: false,
    }
  );

  return {
    providerCodes: queryResult.data,
    isProviderCodesLoading: queryResult.isLoading,
    isProviderCodesError: queryResult.isError,
    providerCodesError: queryResult.error,
  };
};

export const useRequestCoupon = () => {
  const requestCouponMutation = useMutation(MUTATION_KEYS.requestCoupon, async (code: string) => {
    await CouponsApi.init().requestCoupon(code);
  });

  const requestCoupon = useCallback(
    async (code: string) => {
      await requestCouponMutation.mutateAsync(code);
    },
    [requestCouponMutation]
  );

  return {
    requestCoupon,
    isRequestCouponLoading: requestCouponMutation.isLoading,
    isRequestCouponSuccess: requestCouponMutation.isSuccess,
  };
};
